import React from 'react'
import { IconArrowRight, IconSparkles } from '@tabler/icons-react'

import { Card } from '@/components/cards/Card'
import { Button } from '@/components/buttons/Button'
import { SPINE_LEAD } from './AgenticInsights.constants'
import { Spine } from './Spine'
import { ConversionPanel } from './ConversionPanel'
import { getConversionPanelProps, getOpportunityLabel } from './AgenticInsights.helpers'
import { InsightCardMeta } from './InsightCardMeta'
import { DismissInsightButton } from './DismissInsightButton'

// The Insights-tab card: the full goal → obstacle → recommendation spine plus a
// Now → Projected conversion panel. The whole card opens the drawer; the CTA is
// a secondary affordance that does the same.
export const InsightSpineCard = ({ insight, onOpen, onDismiss }) => {
  return (
    <Card clickable className="insight-spine-card" onClick={() => onOpen(insight.id)}>
      {onDismiss && <DismissInsightButton insightId={insight.id} onDismiss={onDismiss} />}
      <div className="insight-spine-card__main">
        <div className="insight-spine-card__tag">
          <IconSparkles className="icon-svg" />
          Insight
          <InsightCardMeta insight={insight} />
        </div>
        <Spine
          nodes={[
            { kind: 'goal', lead: SPINE_LEAD.GOAL, value: getOpportunityLabel(insight) },
            {
              kind: 'obstacle',
              lead: SPINE_LEAD.OBSTACLE,
              value: insight.conversionReason || insight.title,
            },
            {
              kind: 'fix',
              lead: insight.recommendationSummary ? SPINE_LEAD.FIX_SUMMARY : SPINE_LEAD.FIX,
              value: insight.recommendationSummary || insight.recommendation,
              clamp: !insight.recommendationSummary,
            },
          ]}
        />
      </div>
      <div className="insight-spine-card__stat">
        <ConversionPanel {...getConversionPanelProps(insight)} />
        <Button
          brand
          fullWidth
          className="insight-spine-card__cta"
          icon={<IconArrowRight />}
          alignIcon="right"
          onClick={(event) => {
            event.stopPropagation()
            onOpen(insight.id)
          }}
        >
          Review &amp; launch experiment
        </Button>
      </div>
    </Card>
  )
}
